import { render, staticRenderFns } from "./PetitionCourt.vue?vue&type=template&id=f92f7690&scoped=true&"
import script from "./PetitionCourt.vue?vue&type=script&lang=js&"
export * from "./PetitionCourt.vue?vue&type=script&lang=js&"
import style0 from "./PetitionCourt.vue?vue&type=style&index=0&id=f92f7690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92f7690",
  null
  
)

export default component.exports